module.exports = __webpack_public_path__ + "img/map_default_image.7b61dff1.jpg";